<template>
  <div class="inner-card">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />
    <div class="contract-wrap">
      <ValidationObserver v-slot="{ handleSubmit }">
        <div style="text-align: center; font-size: 1.5em; font-weight: bold">
          年員工薪資所得受領人免稅額申報表
          <span style="font-size: 0.8em !important; float: right">
            員工編號:{{ incomeTax.EmployeeNo }}</span
          >
          <hr />
        </div>
        <div>
          <table class="basic-info-table">
            <tr>
              <th></th>
              <th style="width: 25%">姓名</th>
              <th style="width: 25%">出生年月日</th>
              <th style="width: 25%">國民身分證統一編號或統一證號</th>
            </tr>
            <tr>
              <td style="width: 10%; font-weight: bold">薪資受領人</td>
              <td>{{ incomeTax.Name }}</td>
              <td>{{ $common.dateFormatter(incomeTax.Birthday) }}</td>
              <td>{{ incomeTax.IdNo }}</td>
            </tr>
            <tr>
              <td style="font-weight: bold">配偶</td>
              <td>
                <ValidationProvider
                  class="w-100"
                  name="配偶姓名"
                  v-slot="{ errors }"
                  :rules="required ? 'required' : null"
                >
                  <el-input v-model="incomeTax.SpouseName" />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  class="w-100"
                  name="出生年月日"
                  v-slot="{ errors }"
                  :rules="required ? 'required' : null"
                >
                  <el-date-picker
                    class="w-100"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{
                      disabledDate: $common.disabledDateAfterToday,
                    }"
                    placeholder="YYYY-MM-DD"
                    v-model="incomeTax.SpouseBirthday"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  class="w-100"
                  name="配偶國民身分證統一編號或統一證號"
                  v-slot="{ errors }"
                  :rules="required ? 'required' : null"
                >
                  <el-input v-model="incomeTax.SpouseIdNo" />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td style="font-weight: bold">通訊地址</td>
              <td colspan="3">
                {{ incomeTax.Address }}
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-2">
          合於減除扶養親屬免稅額之受扶養親屬（共計 {{ total }} 人）
        </div>
        <ul class="title">
          <li class="mt-2">
            依法得稅法第 17
            條規定，納稅義務人及其配偶之直系尊親屬合於下列條件之一者，每年每人得減除其扶養親屬免稅額。
            <ul class="subtitle">
              <li>(1) 年滿 60 歲；</li>
              <li>(2) 未滿 60 歲，但無謀生能力受納稅義務人扶養。</li>
              <li>
                本人及配偶之直系尊親屬合於上列規定條件者，計有
                {{ incomeTax.Parents ? incomeTax.Parents.length : 0 }} 人
              </li>
            </ul>
          </li>
          <div class="mt-2">
            <el-table :data="incomeTax.Parents" border style="min-width: 100%">
              <el-table-column
                v-if="incomeTax.Parents && incomeTax.Parents.length > 0"
                width="42"
              >
                <template slot-scope="scope">
                  <eva-icon
                    name="minus-square-outline"
                    fill="#606266"
                    width="20"
                    height="20"
                    @click="delRow('parents', scope.$index)"
                  />
                </template>
              </el-table-column>
              <el-table-column width="220">
                <template slot="header">
                  姓名
                  <eva-icon
                    name="plus-square-outline"
                    fill="#606266"
                    width="20"
                    height="20"
                    @click="addRow('parents')"
                  />
                </template>
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`姓名+parents+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.Name" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="稱謂" width="220">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`稱謂+parents+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.Relationship" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="出生年月日" width="220">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`出生年月日+parents+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-date-picker
                      class="w-100"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :picker-options="{
                        disabledDate: $common.disabledDateAfterToday,
                      }"
                      placeholder="YYYY-MM-DD"
                      v-model="scope.row.Birthday"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="國民身分證統一編號或統一證號" width="300">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`國民身分證統一編號或統一證號+parents+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.IdNo" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="符合之條件">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`符合之條件+parents+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-select
                      v-model="scope.row.Type"
                      class="w-100"
                      placeholder="請選擇"
                    >
                      <el-option label="直系尊親屬滿60" :value="1" />
                      <el-option label="直系尊親屬未滿60" :value="2" />
                      <el-option label="子女未成年" :value="3" />
                      <el-option label="子女已成年在學" :value="4" />
                      <el-option label="子女已成年身心障礙" :value="5" />
                      <el-option label="子女已成年無謀生能力" :value="6" />
                      <el-option label="兄弟姊妹未成年" :value="7" />
                      <el-option label="兄弟姊妹已成年在學" :value="8" />
                      <el-option label="兄弟姊妹已成年身心障礙" :value="9" />
                      <el-option label="兄弟姊妹已成年無謀生能力" :value="10" />
                      <el-option label="其他親屬未成年" :value="11" />
                      <el-option label="其他親屬已成年在學" :value="12" />
                      <el-option label="其他親屬已成年身心障礙" :value="13" />
                      <el-option label="其他親屬已成年無謀生能力" :value="14" />
                    </el-select>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <li class="mt-2">
            依法得稅法第 17
            條規定，納稅義務人之子女，合於下列條件之一者，每年每人得減除其扶養親屬免稅額。
            <ul class="subtitle">
              <li>(1) 未成年；</li>
              <li>(2) 已成年，因在校就學受納稅義務人扶養；</li>
              <li>(3) 已成年，因身心障礙受納稅義務人扶養；</li>
              <li>(4) 已成年，因無謀生能力受納稅義務人扶養；</li>
              <li>
                本人之子女合於上列規定條件者，計有
                {{ incomeTax.Children ? incomeTax.Children.length : 0 }} 人
              </li>
            </ul>
          </li>
          <div class="mt-2">
            <el-table :data="incomeTax.Children" border style="min-width: 100%">
              <el-table-column
                v-if="incomeTax.Children && incomeTax.Children.length > 0"
                width="42"
              >
                <template slot-scope="scope">
                  <eva-icon
                    name="minus-square-outline"
                    fill="#606266"
                    width="20"
                    height="20"
                    @click="delRow('children', scope.$index)"
                  />
                </template>
              </el-table-column>
              <el-table-column width="220">
                <template slot="header">
                  姓名
                  <eva-icon
                    name="plus-square-outline"
                    fill="#606266"
                    width="20"
                    height="20"
                    @click="addRow('children')"
                  />
                </template>
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`姓名+children+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.Name" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="稱謂" width="220">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`稱謂+children+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.Relationship" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="出生年月日" width="220">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`出生年月日+children+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-date-picker
                      class="w-100"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :picker-options="{
                        disabledDate: $common.disabledDateAfterToday,
                      }"
                      placeholder="YYYY-MM-DD"
                      v-model="scope.row.Birthday"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="國民身分證統一編號或統一證號" width="300">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`國民身分證統一編號或統一證號+children+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.IdNo" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="符合之條件">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`符合之條件+children+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-select
                      v-model="scope.row.Type"
                      class="w-100"
                      placeholder="請選擇"
                    >
                      <el-option label="直系尊親屬滿60" :value="1" />
                      <el-option label="直系尊親屬未滿60" :value="2" />
                      <el-option label="子女未成年" :value="3" />
                      <el-option label="子女已成年在學" :value="4" />
                      <el-option label="子女已成年身心障礙" :value="5" />
                      <el-option label="子女已成年無謀生能力" :value="6" />
                      <el-option label="兄弟姊妹未成年" :value="7" />
                      <el-option label="兄弟姊妹已成年在學" :value="8" />
                      <el-option label="兄弟姊妹已成年身心障礙" :value="9" />
                      <el-option label="兄弟姊妹已成年無謀生能力" :value="10" />
                      <el-option label="其他親屬未成年" :value="11" />
                      <el-option label="其他親屬已成年在學" :value="12" />
                      <el-option label="其他親屬已成年身心障礙" :value="13" />
                      <el-option label="其他親屬已成年無謀生能力" :value="14" />
                    </el-select>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <li>
            依法得稅法第 17
            條規定，納稅義務人及其配偶之同胞兄弟姊妹，合於下列條件之一者，每年每人得減除其扶養親屬免稅額。
            <ul class="subtitle">
              <li>(1) 未成年；</li>
              <li>(2) 已成年，因在校就學受納稅義務人扶養；</li>
              <li>(3) 已成年，因身心障礙受納稅義務人扶養；</li>
              <li>(4) 已成年，因無謀生能力受納稅義務人扶養；</li>
              <li>
                本人及其配偶之同胞兄弟姊妹合於上列規定條件者，計有
                {{ incomeTax.Siblings ? incomeTax.Siblings.length : 0 }} 人
              </li>
            </ul>
          </li>
          <div class="mt-2">
            <el-table :data="incomeTax.Siblings" border style="min-width: 100%">
              <el-table-column
                v-if="incomeTax.Siblings && incomeTax.Siblings.length > 0"
                width="42"
              >
                <template slot-scope="scope">
                  <eva-icon
                    name="minus-square-outline"
                    fill="#606266"
                    width="20"
                    height="20"
                    @click="delRow('siblings', scope.$index)"
                  />
                </template>
              </el-table-column>
              <el-table-column width="220">
                <template slot="header">
                  姓名
                  <eva-icon
                    name="plus-square-outline"
                    fill="#606266"
                    width="20"
                    height="20"
                    @click="addRow('siblings')"
                  />
                </template>
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`姓名+siblings+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.Name" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="稱謂" width="220">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`稱謂+siblings+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.Relationship" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="出生年月日" width="220">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`出生年月日+siblings+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-date-picker
                      class="w-100"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :picker-options="{
                        disabledDate: $common.disabledDateAfterToday,
                      }"
                      placeholder="YYYY-MM-DD"
                      v-model="scope.row.Birthday"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="國民身分證統一編號或統一證號" width="300">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`國民身分證統一編號或統一證號+siblings+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.IdNo" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="符合之條件">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`符合之條件+siblings+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-select
                      v-model="scope.row.Type"
                      class="w-100"
                      placeholder="請選擇"
                    >
                      <el-option label="直系尊親屬滿60" :value="1" />
                      <el-option label="直系尊親屬未滿60" :value="2" />
                      <el-option label="子女未成年" :value="3" />
                      <el-option label="子女已成年在學" :value="4" />
                      <el-option label="子女已成年身心障礙" :value="5" />
                      <el-option label="子女已成年無謀生能力" :value="6" />
                      <el-option label="兄弟姊妹未成年" :value="7" />
                      <el-option label="兄弟姊妹已成年在學" :value="8" />
                      <el-option label="兄弟姊妹已成年身心障礙" :value="9" />
                      <el-option label="兄弟姊妹已成年無謀生能力" :value="10" />
                      <el-option label="其他親屬未成年" :value="11" />
                      <el-option label="其他親屬已成年在學" :value="12" />
                      <el-option label="其他親屬已成年身心障礙" :value="13" />
                      <el-option label="其他親屬已成年無謀生能力" :value="14" />
                    </el-select>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <li>
            依法得稅法第17條規定，納稅義務人其他親屬或家屬，合於民法 1114 條第 4
            款及第 1123 條第 3
            項規定，且合於下列條件之一者，每年每人得減除其扶養親屬免稅額。
            <ul class="subtitle">
              <li>(1) 未成年；</li>
              <li>(2) 已成年，因在校就學受納稅義務人扶養；</li>
              <li>(3) 已成年，因身心障礙受納稅義務人扶養；</li>
              <li>(4) 已成年，因無謀生能力受納稅義務人扶養；</li>
              <li>
                本人之其他親屬或家屬合於上列規定條件者，計有
                {{ incomeTax.Others ? incomeTax.Others.length : 0 }} 人
              </li>
            </ul>
          </li>
          <div class="mt-2">
            <el-table :data="incomeTax.Others" border style="min-width: 100%">
              <el-table-column
                v-if="incomeTax.Others && incomeTax.Others.length > 0"
                width="42"
              >
                <template slot-scope="scope">
                  <eva-icon
                    name="minus-square-outline"
                    fill="#606266"
                    width="20"
                    height="20"
                    @click="delRow('others', scope.$index)"
                  />
                </template>
              </el-table-column>
              <el-table-column width="220">
                <template slot="header">
                  姓名
                  <eva-icon
                    name="plus-square-outline"
                    fill="#606266"
                    width="20"
                    height="20"
                    @click="addRow('others')"
                  />
                </template>
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`姓名+others+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.Name" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="稱謂" width="220">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`稱謂+others+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.Relationship" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="出生年月日" width="220">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`出生年月日+others+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-date-picker
                      class="w-100"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :picker-options="{
                        disabledDate: $common.disabledDateAfterToday,
                      }"
                      placeholder="YYYY-MM-DD"
                      v-model="scope.row.Birthday"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="國民身分證統一編號或統一證號" width="300">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`國民身分證統一編號或統一證號+others+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-input v-model="scope.row.IdNo" />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
              <el-table-column label="符合之條件">
                <template slot-scope="scope">
                  <ValidationProvider
                    class="w-100"
                    :name="`符合之條件+others+${scope.$index}`"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-select
                      v-model="scope.row.Type"
                      class="w-100"
                      placeholder="請選擇"
                    >
                      <el-option label="直系尊親屬滿60" :value="1" />
                      <el-option label="直系尊親屬未滿60" :value="2" />
                      <el-option label="子女未成年" :value="3" />
                      <el-option label="子女已成年在學" :value="4" />
                      <el-option label="子女已成年身心障礙" :value="5" />
                      <el-option label="子女已成年無謀生能力" :value="6" />
                      <el-option label="兄弟姊妹未成年" :value="7" />
                      <el-option label="兄弟姊妹已成年在學" :value="8" />
                      <el-option label="兄弟姊妹已成年身心障礙" :value="9" />
                      <el-option label="兄弟姊妹已成年無謀生能力" :value="10" />
                      <el-option label="其他親屬未成年" :value="11" />
                      <el-option label="其他親屬已成年在學" :value="12" />
                      <el-option label="其他親屬已成年身心障礙" :value="13" />
                      <el-option label="其他親屬已成年無謀生能力" :value="14" />
                    </el-select>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </ul>
        <div>
          附註：民法 1114 條：左列親屬，互負扶養之義務：
          <ul class="subtitle" style="text-indent: 30px">
            <li>一、 直系血親相互間。</li>
            <li>二、 夫妻之一方與他方之父母同居者，其相互間。</li>
            <li>三、 兄弟姊妹相互間。</li>
            <li>四、 家長家屬相互間。</li>
          </ul>
          <ul class="ul-unstyled">
            <li style="list-style: none; text-indent: 48px">
              民法 1123 條：家置家長。
            </li>
          </ul>
          <ul class="subtitle" style="text-indent: 30px">
            <li>同家之人，除家長外，均為家屬。</li>
            <li>雖非親屬，而以永久共同生活為目的的同居一家者，視為家屬。</li>
          </ul>
        </div>
        <table class="w-100">
          <thead>
            <th></th>
          </thead>
          <tr>
            <td>薪資受領人</td>
            <td>
              {{ incomeTax.Name }}
            </td>
          </tr>
          <tr>
            <td style="width: 10%">填報日期</td>
            <td style="width: 40%">
              {{
                incomeTax.SignedTime
                  ? $common.dateFormatter(incomeTax.SignedTime)
                  : $common.getToday()
              }}
            </td>
          </tr>

          <tr>
            <td>薪資受領人(簽章)</td>
            <td colspan="3" v-show="incomeTax.SignedPicBase64">
              <img
                style="width: 400px; height: 200px; border: 1px solid #efefef"
                :src="incomeTax.SignedPicBase64"
                alt=""
              />
              <el-button size="mini" @click="resigned">重簽</el-button>
            </td>
            <td colspan="3" v-show="!incomeTax.SignedPicBase64">
              <VueSignature
                style="border: 1px solid #efefef"
                ref="signature"
                :defaultUrl="incomeTax.SignedPicBase64 || ''"
                :w="'400px'"
                :h="'200px'"
              />
              <el-button size="mini" @click="clear">清除</el-button>
            </td>
          </tr>
        </table>
        <div style="text-align: center">
          <el-button
            type="primary"
            size="small"
            class="mt-2"
            @click="downloadPDF"
          >
            下載 PDF
          </el-button>
          <el-button
            size="small"
            class="mt-2 save-btn"
            @click="handleSubmit(saveIncomeTax)"
          >
            儲存
          </el-button>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "IncomeTax",

  data() {
    return {
      MatchId: null,
      incomeTax: {},
      total: 0,
      // 簽名圖檔(Base64)
      SignedPicBase64: null,

      img: null,
      required: false,
    };
  },

  methods: {
    // 取得 免稅額申報表
    async getIncomeTax() {
      this.updateLoading(true);
      await this.$api.incomeTax
        .getIncomeTaxReturn(this.MatchId)
        .then((response) => {
          if (response.status === 200) {
            this.SignedPicBase64 = response.data.SignedPicBase64;
            this.incomeTax = response.data;
          }
          this.updateLoading(false);
        });
    },

    // 儲存 免稅額申報表
    saveIncomeTax() {
      // 以實際筆畫判斷，isEmpty() 在 fromDataURL 後會被設為 false，無法判斷是否有簽名
      if (this.$refs.signature.sig.toData().length === 0) {
        if (this.SignedPicBase64 === null) {
          this.$notify({
            title: "失敗",
            message: "尚未簽名",
            type: "error",
            duration: 3500,
          });
          return;
        } else {
          this.SignedPicBase64 = this.incomeTax.SignedPicBase64;
        }
      } else {
        this.SignedPicBase64 = this.$refs.signature.save();
      }

      this.updateLoading(true);
      this.$api.incomeTax
        .putIncomeTaxReturn({
          ...this.incomeTax,
          SignedPicBase64: this.SignedPicBase64,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2000,
            });
            this.getIncomeTax();
          }
          this.updateLoading(false);
        });
    },

    // 下載 免稅額申報表 PDF
    downloadPDF() {
      this.updateLoading(true);
      this.$api.incomeTax
        .downloadIncomeTaxReturnPDF({
          MatchId: this.MatchId,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.type === "application/json") {
              let reader = new FileReader();
              reader.readAsText(response.data, "utf-8");
              reader.onload = () => {
                const { ErrorMessage } = JSON.parse(reader.result);
                this.$notify({
                  title: "失敗",
                  message: ErrorMessage,
                  type: "error",
                  duration: 3500,
                });
              };
            } else {
              let fileName = decodeURIComponent(
                decodeURIComponent(
                  response.headers["content-disposition"].split(
                    "filename*=UTF-8''"
                  )[1]
                )
              );
              let blob = new Blob([response.data], { type: "application/pdf" });
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = fileName;
              a.click();
              window.URL.revokeObjectURL(url);
            }
          }
          this.updateLoading(false);
        })
        .catch(() => {
          this.updateLoading(false);
        });
    },

    // 新增 行
    addRow(type) {
      this.total++;
      switch (type) {
        case "parents":
          this.incomeTax.Parents.push({});
          break;
        case "children":
          this.incomeTax.Children.push({});
          break;
        case "siblings":
          this.incomeTax.Siblings.push({});
          break;
        case "others":
          this.incomeTax.Others.push({});
          break;
      }
    },

    // 刪除 行
    delRow(type, index) {
      this.total--;
      switch (type) {
        case "parents":
          this.incomeTax.Parents.splice(index, 1);
          break;
        case "children":
          this.incomeTax.Children.splice(index, 1);
          break;
        case "siblings":
          this.incomeTax.Siblings.splice(index, 1);
          break;
        case "others":
          this.incomeTax.Others.splice(index, 1);
          break;
      }
    },

    //簽名板 重簽
    resigned() {
      this.incomeTax.SignedPicBase64 = null;
      this.clear();
    },

    // 簽名板 清除
    clear() {
      this.SignedPicBase64 = null;
      this.$refs.signature.clear();
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  watch: {
    "incomeTax.SpouseName": function (val) {
      this.required = Boolean(val);
    },

    "incomeTax.SpouseBirthday": function (val) {
      this.required = Boolean(val);
    },

    "incomeTax.SpouseIdNo": function (val) {
      this.required = Boolean(val);
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.MatchId = this.$route.query.matchId;
    this.getIncomeTax();
  },
};
</script>

<style lang="scss" scoped>
.basic-info-table {
  width: 100%;
  color: #606266;
  font-size: 14px;
  th,
  td {
    border: 1px #ebeef5 solid;
    padding: 12px 10px;
  }
}

.ul-unstyled {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.title {
  list-style: cjk-ideographic;
  margin-left: -9px;
}

.subtitle {
  list-style: none;
  text-indent: -22px;
}

.save-btn {
  background: #22c59a;
  border: none;
  color: #fff;
}

/deep/ .el-table th {
  background-color: #fff;
  color: #606266;
  border-right: 1px #ebeef5 solid;
}
</style>
